import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from 'antd';
import PageLoading from './components/PageLoading';
import EventTypes from './pages/EventTypes';
import EventTypeAddEdit from './pages/EventTypeAddEdit';
import Setting from './pages/Setting';
import SettingAddEdit from './pages/SettingAddEdit';
import Bookings from './pages/Bookings';
// import MainSlider from './pages/MainSlider';
// import MainSliderAddEdit from './pages/MainSliderAddEdit';

const Events = React.lazy(() => import('./pages/Events'));
const EventAddEdit = React.lazy(() => import('./pages/EventAddEdit'));
const NotFound = React.lazy(() => import('./pages/NotFound'));
const NoteTemplates = React.lazy(() => import('./pages/NoteTemplates'));
const NoteTemplateAddEdit = React.lazy(() => import('./pages/NoteTemplateAddEdit'));
const MainSlider = React.lazy(() => import('./pages/MainSlider'));
const MainSliderAddEdit = React.lazy(() => import('./pages/MainSliderAddEdit'));
const ManagHomePage = React.lazy(() => import('./pages/ManageHomePage'));
const ManageHomePageAddEdit = React.lazy(() => import('./pages/ManageHomePageAddEdit'));
const Gallery = React.lazy(() => import('./pages/Gallery'));
const GalleryAddEdit = React.lazy(() => import('./pages/GalleryAddEdit'));

function Router() {
	const routes = [
		{
			path: '/',
			module: <Events />,
		},
		{
			path: '/event-types',
			module: <EventTypes />,
		},
		{
			path: '/event-type/add',
			module: <EventTypeAddEdit />,
		},
		{
			path: '/event-type/edit/:editEventTypeId',
			module: <EventTypeAddEdit />,
		},
		{
			path: '/manage-home-page',
			module: <ManagHomePage />,
		},
		{
			path: '/manage-home-page/add',
			module: <ManageHomePageAddEdit />,
		},
		{
			path: '/manage-home-page/edit/:editManageHomePageId',
			module: <ManageHomePageAddEdit />,
		},
		{
			path: '/events',
			module: <Events />,
		},
		{
			path: '/events/add',
			module: <EventAddEdit />,
		},
		{
			path: '/events/edit/:editEventId',
			module: <EventAddEdit />,
		},
		{
			path: '/setting',
			module: <Setting />,
		},
		{
			path: '/setting/add',
			module: <SettingAddEdit />,
		},

		{
			path: '/note-templates',
			module: <NoteTemplates />,
		},
		{
			path: '/note-template/add',
			module: <NoteTemplateAddEdit />,
		},
		{
			path: '/note-template/edit/:editNoteTemplateId',
			module: <NoteTemplateAddEdit />,
		},
		{
			path: '/bookings',
			module: <Bookings />,
		},
		{
			path: '/main-slider',
			module: <MainSlider />,
		},
		{
			path: '/main-slider/add',
			module: <MainSliderAddEdit />,
		},
		{
			path: '/main-slider/edit/:editSliderId',
			module: <MainSliderAddEdit />,
		},
		{
			path: '*',
			module: <NotFound />,
		},
		{
			path: '/gallery',
			module: <Gallery />,
		},
		{
			path: '/gallery/add',
			module: <GalleryAddEdit />,
		},
		{
			path: '/gallery/edit/:editGalleryId',
			module: <GalleryAddEdit />,
		},
	];

	return (
		<Layout.Content
			style={{
				margin: '0 16px',
				background: '#F2F2F2',
			}}
		>
			<Routes>
				{routes.map((item, i) => (
					<Route key={i} path={item.path} element={<React.Suspense fallback={<PageLoading />}>{item.module}</React.Suspense>} />
				))}
			</Routes>
		</Layout.Content>
	);
}

export default Router;
